import { ResultsCard } from 'libs/searchspring/components/ResultCard'

export const ResultItem = ({ item, className, dataIndex }) => {
  if ('value' in item) {
    return (
      <div className="relative col-span-1">
        <div
          dangerouslySetInnerHTML={{ __html: item.value }}
        />
      </div>
    )
  }

  return (
    <ResultsCard
      result={item}
      className={className}
      dataIndex={dataIndex}
    />
  )
}
